import React from "react";
import { Link, useParams } from "react-router-dom";
import ConsultancyNavbar from "../ConsultancyNavbar";
import ConsultancyFooter from "../ConsultancyFooter";

const UniversityDetailPage = () => {
  const { uniId } = useParams();

  return (
    <div className="consultancy-wrapper">
      <ConsultancyNavbar />

      {/* University Banner Header */}
      <section className="position-relative py-5" style={{ background: "linear-gradient(180deg, rgba(10,10,10,0.85) 0%, rgba(10,10,10,0.98) 100%), url('https://images.unsplash.com/photo-1541339907198-e08756dedf3f?auto=format&fit=crop&w=1200&q=80') center/cover no-repeat", minHeight: "45vh", borderBottom: "1px solid rgba(212, 175, 55, 0.12)" }}>
        <div className="container py-4 position-relative z-2">
          <span className="badge bg-warning text-dark font-weight-bold px-3 py-1 rounded-pill mb-3">QS World Rank #1</span>
          <h1 className="display-4 font-weight-bold consultancy-gold-title mb-2">University of Oxford</h1>
          <p className="text-warning font-weight-bold fs-5 mb-4">🇬🇧 Oxford, Oxfordshire, United Kingdom</p>
          <div className="d-flex flex-wrap gap-3">
            <Link to="/consultancy/book-consultation" className="consultancy-btn-gold px-5 py-3">
              Apply to Oxford <i className="fas fa-paper-plane ml-1"></i>
            </Link>
            <Link to="/consultancy/scholarships" className="consultancy-btn-outline-gold px-4 py-3">
              View Oxford Scholarships <i className="fas fa-award ml-1"></i>
            </Link>
          </div>
        </div>
      </section>

      {/* Content Breakdown */}
      <section className="py-5 container">
        <div className="row g-4">
          <div className="col-lg-8">
            <div className="consultancy-glass-card p-4 p-md-5 mb-4">
              <h3 className="consultancy-gold-title font-weight-bold mb-3">University Overview</h3>
              <p className="text-muted" style={{ lineHeight: "1.8" }}>
                The University of Oxford is the oldest university in the English-speaking world. Recognized globally for ground-breaking scientific research, academic rigor, and world leaders alumni network, Oxford offers top undergraduate and postgraduate degree programs.
              </p>

              <h4 className="consultancy-gold-title font-weight-bold mt-4 mb-3">Popular Degree Programs</h4>
              <div className="row g-3">
                {["M.Sc in Computer Science", "M.Sc in Advanced Computer Science", "Oxford Full-time MBA", "M.Sc in Financial Economics", "B.A. in Philosophy, Politics & Economics", "Ph.D in Biomedical Sciences"].map((p, idx) => (
                  <div key={idx} className="col-md-6">
                    <div className="consultancy-pill-card d-flex align-items-center justify-content-between">
                      <span className="font-weight-bold text-white small">{p}</span>
                      <i className="fas fa-graduation-cap text-warning"></i>
                    </div>
                  </div>
                ))}
              </div>

              <h4 className="consultancy-gold-title font-weight-bold mt-5 mb-3">Entry & Admission Requirements</h4>
              <ul className="text-muted list-unstyled d-flex flex-column gap-2">
                <li><i className="fas fa-check-circle text-warning mr-2"></i> Undergraduate: 90%+ in 10+2 Central / State Boards.</li>
                <li><i className="fas fa-check-circle text-warning mr-2"></i> Postgraduate: 1st Class Honours Bachelor's Degree (GPA 3.7+ / 75%+).</li>
                <li><i className="fas fa-check-circle text-warning mr-2"></i> English Language: IELTS Academic 7.5 (minimum 7.0 in each band).</li>
                <li><i className="fas fa-check-circle text-warning mr-2"></i> Standardized Tests: GRE / GMAT required for business & finance programs.</li>
              </ul>
            </div>
          </div>

          <div className="col-lg-4">
            <div className="consultancy-glass-card p-4 sticky-top" style={{ top: "100px" }}>
              <h5 className="consultancy-gold-title font-weight-bold mb-3">Quick Facts & Deadlines</h5>
              <div className="d-flex flex-column gap-3 mb-4 small text-muted">
                <div className="d-flex justify-content-between pb-2" style={{ borderBottom: "1px solid rgba(255, 255, 255, 0.08)" }}>
                  <span>Tuition Range:</span>
                  <strong className="text-white">£28,000 - £39,000 / yr</strong>
                </div>
                <div className="d-flex justify-content-between pb-2" style={{ borderBottom: "1px solid rgba(255, 255, 255, 0.08)" }}>
                  <span>Fall Intake Deadline:</span>
                  <strong className="text-warning">January 15th</strong>
                </div>
                <div className="d-flex justify-content-between pb-2" style={{ borderBottom: "1px solid rgba(255, 255, 255, 0.08)" }}>
                  <span>Campus Housing:</span>
                  <strong className="text-white">Guaranteed for Year 1</strong>
                </div>
                <div className="d-flex justify-content-between pb-2" style={{ borderBottom: "1px solid rgba(255, 255, 255, 0.08)" }}>
                  <span>Acceptance Rate:</span>
                  <strong className="text-white">17.5%</strong>
                </div>
              </div>

              <Link to="/consultancy/book-consultation" className="consultancy-btn-gold w-100 text-center">
                Start Oxford Application <i className="fas fa-arrow-right ml-1"></i>
              </Link>
            </div>
          </div>
        </div>
      </section>

      <ConsultancyFooter />
    </div>
  );
};

export default UniversityDetailPage;
